import * as React from "react"

const Icon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={48.416}
      height={42.251}
      {...props}
    >
      <path
        data-name="Path 35"
        d="M48.408 11.354v14.534a1.833 1.833 0 01-1.617 1.813c-8.786 1.027-25.443-1.737-29.945 7.267H46.6a1.817 1.817 0 010 3.634h-2.991a2.772 2.772 0 01.113.8 2.85 2.85 0 01-5.7 0 2.772 2.772 0 01.113-.8H22.89a3.06 3.06 0 01.113.8 2.852 2.852 0 01-5.7 0 3.06 3.06 0 01.113-.8h-3.52a1.83 1.83 0 01-1.813-1.821c0-.876 1.329-3.059 1.73-3.891L7.603 3.632H1.816a1.817 1.817 0 010-3.634h7.267c1.926 0 3.135 8.174 3.422 9.534h34.093a1.83 1.83 0 011.813 1.821zm-14.6 6.383l-3.12 3.1v-8.249a1.36 1.36 0 00-2.72 0v8.1l-3.12-3.1c-1.277-1.277-3.173 1.549-1.911 2.81l5.439 5.432a1.315 1.315 0 001.9 0l5.439-5.432c1.285-1.286-.656-3.915-1.909-2.661z"
        fill="#30698d"
        fillRule="evenodd"
      />
    </svg>
  )
}

export default Icon;
